import {Injectable} from '@angular/core';
import {isNullOrUndefined} from 'util';

declare global {
  interface Window {
    dataLayer: any;
    ga: any;
  }
}

@Injectable()
export class GoogleTagManagerService {

  public trackEventWithType(eventName: string, eventType: string) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': eventName,
      'data-gtm-click': !isNullOrUndefined(eventType) ? eventType : undefined
    });
  }

}
